export default __webpack_public_path__ + "assets/img/3b-9GdJ.svg";